import {
 SOCKET_CREATED,
 SOCKET_CONNECTED,
 SOCKET_DISCONNECTED,
 BLOCKS_MINED_ADD,
 RETRIEVING_DATA,
 NO_RPC
} from '../actions/types';

const initialState = {
 latestBlock: null,
 location: {},
 timestamp: 0,
 bcHeight: "SYNCING",
 retrieving: false,
 connected: false,
 no_rpc: true,
 socket: null
}

export const reducer = (state: Object = initialState, action: Object) => {
  switch (action.type) {
    case BLOCKS_MINED_ADD:
      return { ...state, bcHeight: action.payload.height,timestamp:action.payload.timestamp,latestBlock:action.payload};

    case SOCKET_CREATED:
      return { ...state, socket:action.payload.socket,location:action.payload.location}

    case SOCKET_CONNECTED:
      return { ...state, connected: true}

    case SOCKET_DISCONNECTED:
      return { ...state, connected: false,socket:state.socket,no_rpc:true }

    case RETRIEVING_DATA:
      return { ...state, retrieving: action.payload}

    case NO_RPC:
          return {...state, no_rpc:false}
    default:
      return state
  }
}
